/**
* @summary Agregar por Planta Hidroelétrica.
*/
const HYDRO_POWER_PLANT = "HydroPowerPlant";

/**
* @summary Agregar por Baias Hidroelétrica.
*/
const BAY = "Bay";

/**
* @summary Agregar por Parque eólico.
*/
const WIND_PARK = "WindPark";

/**
* @summary Agregar por Complexo eólico.
*/
const WIND_COMPLEX = "WindComplex";

export default
{
	HYDRO_POWER_PLANT,
	BAY,
	WIND_PARK,
	WIND_COMPLEX
};